import Grade from '@/components/Grade'

export function ImportGradeRow({
  label,
  value,
  onChange,
}: {
  label: string
  value: number
  onChange: (value: number) => void
}) {
  return (
    <div className="grid gap-1.5">
      <div className="text-xs font-medium text-warm-gray-800">{label}</div>
      <div className="grid grid-cols-7 gap-1">
        <button
          type="button"
          className={`rounded-sm h-8 text-xs cursor-pointer ${
            value === 0
              ? 'bg-purple-300 hover:bg-purple-300'
              : 'bg-warm-gray-200 hover:bg-warm-gray-300'
          }`}
          onClick={() => onChange(0)}
        >
          Ingen
        </button>
        {[1, 2, 3, 4, 5, 6].map((number) => (
          <Grade
            key={number}
            number={number}
            isSelected={value === number}
            onClick={() => onChange(number)}
          />
        ))}
      </div>
    </div>
  )
}

export function AddExamButton({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex w-fit items-center rounded-md border border-warm-gray-300 px-3 py-1.5 text-xs font-medium text-warm-gray-800 cursor-pointer hover:bg-warm-gray-100"
    >
      {label}
    </button>
  )
}
